import React, {Component} from "react"
import {Col} from "react-bootstrap"
import scrollIntoView from "scroll-into-view-if-needed"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {CompanyNewsTile} from "@irati/types"
import {deleteCompanyNewsRow} from "@irati/culture-hub/services/homepage"
import tracking from "@irati-tracking/homepage"

import {HomePageView} from "../types"
import HomePageRow from "../HomePageRow"
import ContentColumns from "./Content/ContentColumns"
import Empty from "./Empty"
import NewRowModal from "./NewRow/Modal"
import Title from "./Title"
import {DeleteRowButton, RowButtonWrapper} from "./styled"
import {isRowEmpty} from "./utils/isRowEmpty"
import companyNewsToRows from "./utils/companyNewsToRows"

interface Props extends WithAuth {
  companyNews: CompanyNewsTile[],
  id: string,
  pageView: HomePageView,
  toggleEditView: () => void
}

interface State {
  load?: boolean,
  newRowId?: number
}

class HomepageTiles extends Component<Props, State> {
  state: State = {}

  componentDidMount() {
    scrollIntoView(document.getElementById("edit-culture-hub"), {
      scrollMode: "if-needed",
      behavior: "smooth"
    })
    if (!this.props.companyNews.length) {
      this.openModal()
    }
  }

  openModal = () => {
    tracking.homePageCreateRowModal()
    const {companyNews} = this.props
    const rows = companyNewsToRows(companyNews)
    this.setState({
      newRowId: rows.length
    })
  }

  closeModal = () => this.setState({newRowId: undefined})

  removeRow = (tilesToDelete: CompanyNewsTile[]) => {
    const {
      auth: {
        business: {uuid}
      }
    } = this.props
    const variables = {
      tenantId: uuid,
      tiles: tilesToDelete
    }

    this.setState({load: true})
    deleteCompanyNewsRow(variables).then(() => {
      tracking.homePageRemoveRow()
      this.setState({load: false})
    })
  }

  onExitEdit = () => {
    this.props.toggleEditView()
  }

  render() {
    const {load, newRowId} = this.state
    const {companyNews, pageView} = this.props

    const rows = companyNewsToRows(companyNews)
    const lastRow = rows.length > 0 ? rows[rows.length - 1] : []

    return (
      <>
        <HomePageRow id="edit-culture-hub" isEditRowView={pageView === HomePageView.EDIT_LAYOUT_VIEW}>
          <Col xs={12}>
            <Title onExitEdit={this.onExitEdit} />
            {companyNews.length === 0 && <Empty onClick={this.openModal} />}
            {rows.map((row, i: number) => (
              <ContentColumns key={i} pageView={pageView} companyNewsRow={row} />
            ))}

            {pageView === HomePageView.EDIT_CONTENT_VIEW && companyNews.length > 0 && (
              <RowButtonWrapper>
                {isRowEmpty(lastRow) && (
                  <DeleteRowButton disabled={load} onClick={() => this.removeRow(lastRow)}>
                    <FormattedMessage id="platform.homepage.companyNews.deleteRow.button" />
                  </DeleteRowButton>
                )}

                {/* can disable/remove with: doesRowContainEmpty(rows[rows.length - 1]) */}
                <Button disabled={load} primary onClick={this.openModal}>
                  <FormattedMessage id="platform.homepage.companyNews.newRow.button" />
                </Button>
              </RowButtonWrapper>
            )}
          </Col>
        </HomePageRow>
        {newRowId !== undefined && <NewRowModal onClose={this.closeModal} onRemoveRow={this.removeRow} rowInt={newRowId} />}
      </>
    )
  }
}

export default withAuth(HomepageTiles)
